import React, { Component } from 'react';
import {mapType,trim_str} from '../../../utils/constants';
import find from 'lodash/find';
import filter from 'lodash/filter';
import UploadCategoryLanding from './../UploadCategoryLanding';
import UploadFile from './UploadFile';
import ReviewMapping from './ReviewMapping';
import withStep from './withStep';
import uniqBy from 'lodash/uniqBy';

import MatchColumns from './../../../components/OrganizationSetup/Components/MatchColumns/MatchColumns.jsx'
import Review from './../../../components/OrganizationSetup/Components/Review/Review.jsx'
import moment from 'moment';
import { employeeCollectionDatabaseColumns,applicantCollectionDatabaseColumns } from '../../../utils/constants';
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import { getFlatDataFromTree } from 'react-sortable-tree';
import upload_file from './../../../assets/upload_file.svg';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';
import Loading from './../../../hoc/Loading/Loading';
import findIndex from 'lodash/findIndex';
import numeral from 'numeral'

class CsvUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      currentStep : 1,
      newOffices: [],
      matchedColumns : [],
      existingMatchedColumns : [],
      selectedDate : moment(),
      dataType:"",
      allColumns : [],
      rowData : [],
      newOfficesFound:[],
      emptyOffices:[],
      problemOffices:[],
      file : null,
      existingMapping : {},
      fileName:"",
      error:false,
      errorMessage:'',
      mappingData:[],
      existingEmployeeMatchedColumns : [],
      existingApplicantMatchedColumns : [],
    }
  }

  componentDidMount() {

    const { organizationId } = this.props.user.profile;
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {

      const payload = data.data;
      const {mapping} = payload;
      const { employeeData, applicantData } = mapping;
      
      let filterAllValueInMapping = {...mapping};
      if(filterAllValueInMapping.occupation) {
        const i = findIndex(filterAllValueInMapping.occupation.data,(o) => (o.key === "ALL" || o.key === "All"));
        if(i > -1) {
          filterAllValueInMapping.occupation.data.splice(i,1);
        }
      }
      if(filterAllValueInMapping.seniority) {
        const i = findIndex(filterAllValueInMapping.seniority.data,(o) => (o.key === "ALL" || o.key === "All"));
        if(i > -1) {
          filterAllValueInMapping.seniority.data.splice(i,1);
        }
      }

      this.setState({
        existingMapping : {...payload,mapping : filterAllValueInMapping}
      })

      if(employeeData && employeeData.data.length > 0) {
        this.setState({mappingData:employeeData})
        const employeeDataMapping = employeeData.data.map((o) => {
          const e = {};
          const match = find(employeeCollectionDatabaseColumns,{value : o.key});
          e.csvField = o.columnName;
          e.value = {
            value : o.key,
            label : match ? match.label : ''
          }
          return e;
        })
        this.setState({
          existingEmployeeMatchedColumns : employeeDataMapping
        })
      }

      if(applicantData && applicantData.data.length > 0) {
        this.setState({ mappingData:applicantData });
        const applicantDataMapping = applicantData.data.map((o) => {
          const e = {};
          const match = find(applicantCollectionDatabaseColumns,{value : o.key});
          e.csvField = o.columnName;
          e.value = {
            value : o.key,
            label : match ? match.label : ''
          }
          return e;
        })
        this.setState({
          existingApplicantMatchedColumns : applicantDataMapping
        })
      }
    })
  }


  goNext = () => {
    this.setState((prev) => ({currentStep : (prev.currentStep + 1) }));
  }

  goBack = () => {
    this.setState((prev) => ({currentStep : (prev.currentStep - 1), error : false }));
  }

  handleMatchColumns = (matchedColumns) => {
    // console.log('')
    this.setState({
      matchedColumns : matchedColumns
    });
    this.goNext();
  }

  handleFileUpload = (fields,data,file) => {
    const {currentStep, dataType, existingEmployeeMatchedColumns, existingApplicantMatchedColumns} = this.state;
    const matchedColumns = [];
    const existingMatchedColumns = dataType==="Employee" ? existingEmployeeMatchedColumns : existingApplicantMatchedColumns;

    this.setState({existingMatchedColumns});
    fields.forEach((fieldName) => {
      const match = find(existingMatchedColumns,(c) => c.csvField === fieldName);
      if(match) {
        matchedColumns.push(match);
      }
    })

    this.setState({
      allColumns : fields,
      rowData : data,
      file : file,
      fileName:file.name,
      currentStep : currentStep + 1,
      matchedColumns : matchedColumns
    });
  }

  getStarted = () => {
    const {existingMapping} = this.state;
    this.goNext();
  }

  handleImport = () => {
    // console.log("handle Import")
    const {matchedColumns,rowData,selectedDate,existingMapping, dataType, fileName} = this.state;
    const formattedDate = selectedDate.format('YYYY-MM-DD') + 'T00:00:00.000Z';
    const {organizationId} = this.props.user.profile;
    const {isSetupFlow} = this.props;
    // return;
    const {mappedColumns,staticHierarchy} = organizationId;
    const flat = getFlatDataFromTree({treeData : staticHierarchy,getNodeKey: ({ node }) => 
      node.id,ignoreCollapsed: false});
      // console.log('hier---', flat)
    const allOfficePaths = flat.map((p) => {
      // console.log(p)
      const o = {};
      o.path = p.path.join('#');
      o.name = p.node.title;
      o.officeKey = p.node.officeKey;
      o.namesArr = p.node.officeNameArr &&  p.node.officeNameArr.length>0? p.node.officeNameArr.map(e=>e.title):[]
      return o;
    });
    console.log('allOffices ---- ',allOfficePaths)
    let dataInit, oPath, oPathName, oOfficeKey

    if(dataType==="Employee"){
      dataInit = "employee"
      oPath = "employeeOfficePath"
      oPathName = "employeeOfficeName" 
      // oOfficeKey = "employeeOfficeKey"
      oOfficeKey = "officeKey"
    } else {
      dataInit = "applicant"
      oPath = "applicantOfficePath"
      oPathName = "applicantOfficeName" 
      // oOfficeKey = "applicantOfficeKey"
      oOfficeKey = "officeKey"
    }

    // console.log(dataType, dataInit,oPath, oPathName, oOfficeKey)

    let emptyOffices = []
    const officeHierarchy = find(matchedColumns,(o) => o.value.value === oPath);
    const genderCol = find(matchedColumns,(o) => o.value.value === "gender");
    const baseSal = find(matchedColumns,(o) => o.value.value === "baseSalary");
    const compaRatio = find(matchedColumns,(o) => o.value.value === "compaRatio");

    let newOfficesFound=[]
    console.log('office ---- ', officeHierarchy)
    const mappedEmployeeData = rowData.map((row) => {
      // console.log('row---',row)
      let rowOfficeName
      const mappedRow = {};
      for(let key in row) {

        if(genderCol &&( key === genderCol.csvField) && (row[key]===null || row[key]===undefined || !row[key] || row[key]==="undefined")) {
          row[key]="empty"
          mappedRow[genderCol.value.value] = row[key]
        }
       

        if(baseSal && key === baseSal.csvField) {
          let r = row[key]
          let n = numeral(r)
          let bval = n._value
          let val = baseSal.value.value
          row[key]=bval
        }
       
        if(compaRatio && key === compaRatio.csvField) {
          let r = row[key]
          let n = numeral(r)
          let cval = n._value
          let val = compaRatio.value.value
          row[key]=cval
        }
       

        console.log(row, ` -- and key is: ${key}`)

        if(officeHierarchy && key === officeHierarchy.csvField) {

          let map; 

           rowOfficeName = row[key] && row[key].toString().length>0? row[key].toString().replace(/^\s+|\s+$|\s+(?=\s)/g, ''):''
          console.log('rowOfficeName----', rowOfficeName)
        
          if(rowOfficeName==''){
            return emptyOffices.push(row)
          } 

          if( find(allOfficePaths,{name: rowOfficeName }) ) {
            map = find(allOfficePaths,{name: rowOfficeName})
          } else {
            allOfficePaths.map(e=>{
              if(e.namesArr.indexOf( rowOfficeName )>-1){
                map = e
                return map
              } 
            })
          }
          console.log('is office found ---- ', map)
          if(map && map.path) { 
            mappedRow[oPath] = map.path;
            mappedRow[oOfficeKey]=map.officeKey
            mappedRow[oPathName] = map.path.split('#').pop();
            if(row[key]!== mappedRow[oPathName]){
              mappedRow['currentOfficeName'] = trim_str(rowOfficeName)
            }
          } else {
            
            newOfficesFound.push({value:row[key], label: row[key] })
            mappedRow['newOfficePath'] = rowOfficeName
          }
          // console.log(mappedRow)
        } else {
          const map = find(matchedColumns,{csvField : key});
          console.log('ELSE after Hier ---- ', map)
          if(genderCol &&( key === genderCol.csvField) && (row[key]===null || row[key]===undefined || !row[key] || row[key]==="undefined")) {
            row[key]="empty"
            mappedRow[genderCol.value.value] = row[key]
          }
  
          if(baseSal && key === baseSal.csvField) {
            let r = row[key]
            let n = numeral(r)
            let bval = n._value
            row[key]=bval
          }
         
          if(compaRatio && key === compaRatio.csvField) {
            let r = row[key]
            let n = numeral(r)
            let cval = n._value
            row[key]=cval
          }
          if(map) {
            console.log('mapp---',map)
            if(map.value.length!=undefined && map.value.toString().length>0){
              map.value.map(e=> mappedRow[e.value]= row[key].toString())
            }else{
              mappedRow[map.value.value] = row[key]
            }
          }
        }

      }
      mappedRow.selectedDate = formattedDate;

      if(rowOfficeName && rowOfficeName!=''){
        return mappedRow;
      }  
     
    });

    // console.log('mappedEmployeeData ---- ',mappedEmployeeData);

    // return

    let invalidRecords=[]

    invalidRecords = filter(mappedEmployeeData,(o) => {
      if(dataInit==="applicant"){
        return !o.applicantOfficePath || o.applicantOfficePath.length === 0
      } else {
        return !o.employeeOfficePath || o.employeeOfficePath.length === 0
      }
    })

    console.log('no offices included----',invalidRecords)


    invalidRecords.concat(emptyOffices)



    if(invalidRecords.length > 0) {
    
      let result = emptyOffices.length>0?emptyOffices:[]
      let newOffices= uniqBy(invalidRecords, 'newOfficePath')

      if(newOfficesFound.length>0){
        result.concat(newOfficesFound)
      }

      if(newOffices.length>0){
        result.concat(newOffices)
      }

      console.log('emptyOffices ---', emptyOffices)
      console.log('problemOffices--- ', result)
      this.setState({
        error:true,
        errorMessage:'Uploaded .csv file contains offices not in your organization. Please upload another .csv file.',
        newOfficesFound:uniqBy(newOfficesFound, 'value'),
        newOffices,
        emptyOffices,
        problemOffices: result
      })
      console.log('invalid entries..');
      return;
    } 


    const invalidGenderRecords = filter(mappedEmployeeData,(o) => !o.gender);
    if(invalidGenderRecords.length > 0) {

      


      this.setState({error:true, 
        errorMessage: 'Uploaded .csv file does not contain gender information. Please match gender column.'})
      // console.log('invalid entries..GENDER');
      return;
    }
    let listType = dataType==="ATS"?"applicantList":"employeeList"



    let mappingType = dataType==="Employee"?"employeeData":"applicantData"
    
    
    const mappingPaylod = {
      mappingType,
      data : matchedColumns.map((c) => {
        const a = {};
        a.key = c.value.value;
        a.values = c.csvField;
        return a;
      })
    }



    // console.log(dataPayload, mappingPaylod);
    


    let postUrl = dataType==="Employee"?url.saveEmployeeData:url.saveApplicantData


    const dataPayload = {
      mappingType,
      fileName,
      selectedDate:formattedDate,
      listType : mappedEmployeeData,
      matchedColumns: mappingPaylod.data
    }
   
    
   let that = this
    axios.all([
      axios.post(url.saveMapping,mappingPaylod),
      axios.post(postUrl,dataPayload),
    ])
    .then(axios.spread(function (mapping, csv) {
      // console.log('success')
          if(isSetupFlow) {
            that.props.history.push('/home');
          } else {
            that.props.history.push('/home/upload-data/success');
          }
    })).catch((err) => {

      if(err && err.response && err.response.data&& err.response.data.errors ){
        console.log('err Resp ---- ', err.response)
        let message =  err.response.data.errors.message
       
        this.setState({
          error:true,
          errorMessage:message
        })
      } else { 
        this.setState({error:true,
          errorMessage:err.message
        })
      }
      return
    })


    // axios.post(url.saveMapping,mappingPaylod).then(({data}) => {
    //   console.log("success")
    // });
    // axios.post(postUrl,dataPayload).then(({data}) => {
    //   if(isSetupFlow) {
    //     this.props.history.push('/home');
    //   } else {
    //     this.props.history.push('success');
    //   }
    // });


  }

  isExistingMapping = (o) => {
    return o && o !== 'occupation' || o !== 'seniority' || o !== 'gender' || o !== 'performance'|| o !== 'ethnicity' ;
  }

  handleDateChanged = (date) => {
    // console.log(date);
    this.setState({selectedDate : date});
  }

  handleFileType=(val)=>{
    this.setState({dataType:val})
  }

  fileName=(val)=>{
    // console.log(val)
    this.setState({fileName:val})
  }
   
  render() { 
    const {currentStep,allColumns,rowData,file,matchedColumns,
      selectedDate,existingMapping, error, errorMessage, newOffices, fileName,
      emptyOffices,problemOffices,
      newOfficesFound} = this.state;
    const {isSetupFlow} = this.props;
    const {organizationId} = this.props.user.profile;
    const MatchColumn = withStep(MatchColumns,2);
    const UploadDataReview = withStep(Review,3);
    let fileType = this.state.dataType
    // console.log(fileType)
    return ( 
      <div className="mb30 dataUploadFileContainer">
        {
          !isSetupFlow ? 
          <EnterpriseBreadcrumb 
            // top={''}
            linkText="Upload Data" 
            link="/home/upload-data" 
            activeText="Import From a File"
            {...this.props}
            /> : null
        }
        {
          currentStep === 1 ?
          <UploadCategoryLanding
            selectedCategory="Import from a File"
            categoryDescription="You can upload employee data by importing a .csv file. The data uploaded when you import from a .csv file, will be only those in the .csv columns and values that have been matched/mapped to specific employee data fields, and for the enterprise offices that have been mapped to your organizational hierarchy."
            categoryIllustration={upload_file}
            nextStep={this.getStarted}
          /> : 
          currentStep === 2 ?
          <ReviewMapping
            nextStep={this.goNext}
            existingMapping={existingMapping}
            organizationData={organizationId}
          /> :
          currentStep === 3 ?
          <UploadFile
            selectedDate={selectedDate}
            onFileUpload={this.handleFileUpload}
            onDateChanged={this.handleDateChanged}
            onFileTypeSelect={this.handleFileType}
            fileType={this.state.dataType?this.state.dataType:""}
            fileUploadName={this.fileName}
          /> :
          currentStep === 4 ?
          <MatchColumn
            goBack={this.goBack}
            top="mt30"
            instruction="Now, let’s match columns in your uploaded file to types of data needed to calculate KPIs."
            csvFields={allColumns}
            csvData={rowData}
            matchedColumns={matchedColumns}
            type={mapType.uploadEmployeeDataCsv}
            show
            existingMapping={existingMapping}
            allowMoreColumnsMatch={true}
            nextBtnTxt='Continue'
            onMatchedColumns={this.handleMatchColumns}
            showDropdown={true}
            dropdownValues={fileType==="Applicant"?applicantCollectionDatabaseColumns:employeeCollectionDatabaseColumns}
          /> :
          currentStep === 5 ?
          <UploadDataReview
            top="mt30"
            selectedDate={selectedDate}
            instruction="Please review your selections below before completing the file import process."
            goBack={this.goBack}
            fileName={fileName}
            uploadDataAllColumns={allColumns}
            uploadDataMappedColumns={matchedColumns}
            nextBtnAction={this.handleImport}
            type={mapType.uploadEmployeeDataCsv}
            file={file}
            fileType={fileType}
            nextBtnTxt="Import"
            error={error}
            newOffices={newOffices}
            newOfficesFound={newOfficesFound}
            // hierarchy={flat}
            emptyOffices={emptyOffices}
            problemOffices={problemOffices}
            errorMessage={errorMessage}
            reviewHeading="These are your final selections for this file import."
            {...this.props}
          />
          : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}
 
export default connect(mapStateToProps)(Loading(CsvUpload,axios));
